import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { useSpring, animated } from "react-spring"

import ImgPlaceholder from "./imgPlaceholder"

const SingleImage = ({ isVisible, post }) => {
  const [springProps, setSpringProps] = useSpring(() => ({
    config: { duration: 50 },
    opacity: 0,
  }))

  if (!isVisible) {
    setSpringProps({ opacity: 0 })
    return (
      <div>
        <ImgPlaceholder />
      </div>
    )
  } else {
    setSpringProps({ opacity: 1 })
    return (
      <animated.div style={{ ...springProps }}>
        <Img
          className="img h-full w-full"
          fluid={post.localFile.childImageSharp.fluid}
          loading="eager"
        />
      </animated.div>
    )
  }
}

export default SingleImage
